import { useState } from "react";
import { InputWithSuffix } from "../../../components/ui/input-suffix.tsx";
import { TokenIcon, type TokenName } from "../../../components/ui/token-icon.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog.tsx";
import { Input } from "../../../components/ui/input.tsx";
import { cn } from "../../../utils/cn.ts";

export function TradeSetting({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [slippage, setSlippage] = useState("0.1");
  const [deadline, setDeadline] = useState("10");

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-[#222428] text-white border-none">
        <DialogHeader>
          <DialogTitle asChild>
            <div className="text-[12px] text-white flex items-center w-full">
              <span className="text-[12px] font-bold">交易设置</span>
              {/* <span></span> */}
            </div>
          </DialogTitle>
        </DialogHeader>
        <div>
          <div className="text-[10px] font-regular">滑点容差 ?</div>
          <div className="flex items-center justify-between gap-x-1 mt-2">
            {["0.1", "0.2", "0.5", "1"].map((item) => (
              <div
                key={item}
                className={cn(
                  "text-[10px] font-regular rounded-full bg-[#3A3F44] w-full py-2 text-center",
                  slippage === item ? "bg-[#F6A702] border border-white" : ""
                )}
                onClick={() => setSlippage(item)}
              >
                {item}%
              </div>
            ))}
          </div>
          <InputWithSuffix
            wrapperClasses="border !border-[#F6A702] w-full mt-1 rounded-lg"
            className="border-none focus-visible:ring-0  text-right pr-0 text-[10px]"
            type="number"
            suffix={
              <span className="text-[10px] font-regular text-[#F6A702]">%</span>
            }
          />
        </div>
        <div>
          <div className="text-[10px] font-regular">交易截止期限 ?</div>
          <div className="flex items-center justify-between gap-x-1 mt-2">
            {["10", "20", "30"].map((item) => (
              <div
                key={item}
                className={cn(
                  "text-[10px] font-regular rounded-full bg-[#3A3F44] w-full py-2 text-center",
                  deadline === item ? "bg-[#F6A702] border border-white" : ""
                )}
                onClick={() => setDeadline(item)}
              >
                {item} 分钟
              </div>
            ))}
          </div>
          <InputWithSuffix
            wrapperClasses="border !border-[#F6A702] w-full mt-1 rounded-lg"
            className="border-none focus-visible:ring-0  text-right pr-0 text-[10px]"
            type="number"
            suffix={
              <span className="text-[10px] font-regular text-[#F6A702]">
                分钟
              </span>
            }
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
